import { BaseContainerModel } from '../base-container.model';
export class PointPurchaseRequest extends BaseContainerModel {
  constructor(
    public websiteCode: string, 
    public entityHdrGuid: string, 
    public membershipHdrGuid: string, 
    public fiItemGuid: string,
    public parentFiItemGuid: string,
    public pricingSchemeGuid: string, 
    public quantityBase: number,
    public shouldRedeem: boolean
  ) {
    super();
  }
}
